import { render, staticRenderFns } from "./DetailsSectionCoursesTable.vue?vue&type=template&id=6a9b7606&"
import script from "./DetailsSectionCoursesTable.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionCoursesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports